import React, { useState } from "react";
import styles from "./ToolBlock.module.css";
import edit_icon from "../../../../resourсes/edit-icon.svg";
import add_icon from "../../../../resourсes/add-icon.svg";
import view_icon from "../../../../resourсes/view_icon.svg";

function ToolBlock({
  data,
  buildingId,
  showForm,
  editAccess,
  viewAccess,
  addAccess,
}) {
  return (
    <div className={styles["buttons-block"]}>
      {addAccess && (
        <button
          data-type={`add`}
          onClick={showForm}
          className={styles["add-btn"]}
        >
          <span className={styles["plus-icon"]}></span>
          <p className={styles.buttons_text}>Добавить</p>
        </button>
      )}
      {editAccess && (
        <button
          data-type={`edit`}
          onClick={showForm}
          disabled={!data?.length || !buildingId}
          className={styles["other-btn"]}
        >
          <p className={styles.buttons_text}>Редактировать</p>
        </button>
      )}
      {viewAccess && (
        <button
          data-type={`view`}
          onClick={showForm}
          disabled={!data?.length || !buildingId}
          className={styles["other-btn"]}
        >
          <p className={styles.buttons_text}>Просмотр</p>
        </button>
      )}
    </div>
  );
}

export default ToolBlock;
